import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

export const MetadataListSubGroup = styled.div`
    padding: 0.714rem;
    margin: 0.714rem;
    border: 1px solid #bbb1aa; // TODO-TH
`;

export const StyledMetadataList = styled.ul`
    margin: 0;
    list-style: none;
    padding: ${getBaseTheme().spaces.insetSquish.s};
`;
export const NoMetaDataMessage = styled.div`
    span {
        margin: 0;
    }
`;
